import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createCoupon,
  getCoupons,
  getActiveCoupons,
  updateCoupon,
  deleteCoupon,
  applyCoupon,
} from "../../../services/coupons";
import toast from "react-hot-toast";
import { useState } from "react";

function useCoupon() {
  const queryClient = useQueryClient();
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  // Fetch all coupons
  const {
    data: coupons,
    isLoading: isGettingCoupons,
    error: getCouponsError,
  } = useQuery({
    queryKey: ["coupons"],
    queryFn: getCoupons,
  });

  // Fetch active coupons
  const {
    data: activeCoupons,
    isLoading: isGettingActiveCoupons,
    error: getActiveCouponsError,
  } = useQuery({
    queryKey: ["activeCoupons"],
    queryFn: getActiveCoupons,
  });

  // Create coupon mutation
  const {
    mutate: createCouponFn,
    isLoading: isCreatingCoupon,
    error: createCouponError,
  } = useMutation({
    mutationFn: createCoupon,
    onSuccess: () => {
      queryClient.invalidateQueries(["coupons"]);
      queryClient.invalidateQueries(["activeCoupons"]);
      toast.success("Coupon has been created successfully!");
    },
    onError: (err) => {
      // console.log("coupon error: ", err);
      toast.error("Error Creating Coupon");
    },
  });

  // Update coupon mutation
  const {
    mutate: updateCouponFn,
    isLoading: isUpdatingCoupon,
    error: updateCouponError,
  } = useMutation({
    mutationFn: ({ updatedData, couponId }) =>
      updateCoupon(updatedData, couponId),
    onSuccess: () => {
      queryClient.invalidateQueries(["coupons"]);
      queryClient.invalidateQueries(["activeCoupons"]);
    },
  });

  // Delete coupon mutation
  const {
    mutate: deleteCouponFn,
    isLoading: isDeletingCoupon,
    error: deleteCouponError,
  } = useMutation({
    mutationFn: deleteCoupon,
    onSuccess: () => {
      queryClient.invalidateQueries(["coupons"]);
      queryClient.invalidateQueries(["activeCoupons"]);
      toast.success("Coupon has been deleted successfully!");
    },
    onError: () => {
      toast.error("some error occured");
    },
  });

  // apply coupon
  const applyCouponMutation = useMutation({
    mutationFn: (couponCode) => applyCoupon(couponCode),
    onSuccess: (data) => {
      setAppliedCoupon(data);
      queryClient.invalidateQueries(["coupons"]);
      toast.success("coupon applied!");
    },
    onError: () => {
      toast.error("some error occured");
    },
  });

  return {
    // Queries
    coupons,
    isGettingCoupons,
    getCouponsError,
    activeCoupons,
    isGettingActiveCoupons,
    getActiveCouponsError,
    // Mutations
    createCouponFn,
    isCreatingCoupon,
    createCouponError,
    updateCouponFn,
    isUpdatingCoupon,
    updateCouponError,
    deleteCouponFn,
    isDeletingCoupon,
    deleteCouponError,
    // apply coupon
    applyCouponFn: applyCouponMutation.mutate,
    isApplyingCoupon: applyCouponMutation.isLoading,
    appliedCoupon,
  };
}

export default useCoupon;
